import React, { Component } from "react";
import "./styles.scss";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const MetricsBlock = () => {
  return (
    <div className="metrics-color-text">
      <p className="label-text"><Skeleton width={'100%'} height={28} /></p>
    </div>
  )
}

class SubscriptionLoader extends Component {
  render() {
    return (
      <div className="subscription-loader">
        <SkeletonTheme className="skeleton-loader" color="#848484" highlightColor="#373737">
          <div className="subscription-title-block">
            <div className="subscription-title">
              <Skeleton width={120} height={40} />
            </div>
          </div>
          <>
            <p className="contact-us-wrapper">
              <Skeleton width={'50%'} height={16} />
            </p>
            {Array(1).fill().map((item, i) => (
              <div key={item} className="subscription-parent-block">
                <div className="subscription-metrics-container">
                  <p className="subscription-title"><Skeleton width={'60%'} height={28} /></p>
                  <p className="subscription-address"><Skeleton width={'30%'} height={12} style={{ marginTop: 6 }} /></p>
                  <div className="subscription-package-details">
                    <Skeleton width={'50%'} height={20} />
                  </div>
                  <div className="subscription-date">
                    <Skeleton width={'30%'} height={14} style={{ marginTop: 6 }} />
                  </div>
                  <>
                    <div className="subscription-credits"><Skeleton width={40} height={14} style={{ marginTop: 6 }} /></div>
                    <div className="course-metrics-container">
                      <div className="course-metrics">
                        <Skeleton width={'100%'} height={40} />
                      </div>
                      <div className="course-metrics-wrapper">
                        <div className="course-metrics-labels">
                          <div className="course-metrics-row course-row-margin">
                            <MetricsBlock />
                            <MetricsBlock />
                          </div>
                          <div className="course-metrics-row">
                            <MetricsBlock />
                            <MetricsBlock />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
                <Skeleton width={'100%'} height={0.5} style={{ marginTop: 16 }} />
              </div>
            ))}
          </>
        </SkeletonTheme>
      </div>
    );
  }
}

export default SubscriptionLoader;
